module.exports = __webpack_public_path__ + "static/media/illustrasi-vendor-bergabung.f87e7108.svg";